import { Text, View } from '@react-pdf/renderer';
import { type PropsWithChildren, type ReactElement } from 'react';
import { PDF_STYLES } from '../../styles';

interface SectionBoxProps extends PropsWithChildren {
  title: string;
  sizing?: 'fill' | 'content';
}

export const SectionBox = ({ title, children, sizing = 'fill' }: SectionBoxProps): ReactElement => (
  <View
    style={sizing === 'fill' ? [PDF_STYLES.section, PDF_STYLES.sectionFill] : PDF_STYLES.section}
  >
    <Text style={PDF_STYLES.sectionTitle}>{title}</Text>
    <View style={PDF_STYLES.sectionContent}>{children}</View>
  </View>
);
